"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _objectSpread2 = _interopRequireDefault(require("@babel/runtime/helpers/objectSpread"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _servicesCore = require("@makerdao/services-core");

var _multicall = require("@makerdao/multicall");

var MulticallService =
/*#__PURE__*/
function (_PublicService) {
  (0, _inherits2["default"])(MulticallService, _PublicService);

  function MulticallService() {
    var name = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'multicall';
    (0, _classCallCheck2["default"])(this, MulticallService);
    return (0, _possibleConstructorReturn2["default"])(this, (0, _getPrototypeOf2["default"])(MulticallService).call(this, name, ['web3', 'smartContract']));
  }

  (0, _createClass2["default"])(MulticallService, [{
    key: "createWatcher",
    value: function createWatcher(config) {
      var _this$get = this.get('web3'),
          rpcUrl = _this$get.rpcUrl;

      var multicallAddress = this.get('smartContract').getContractAddress('MULTICALL');
      this._watcher = (0, _multicall.createWatcher)([], (0, _objectSpread2["default"])({
        rpcUrl: rpcUrl,
        multicallAddress: multicallAddress
      }, config));
    }
  }, {
    key: "disconnect",
    value: function disconnect() {// TODO
    }
  }, {
    key: "watcher",
    get: function get() {
      return this._watcher;
    }
  }]);
  return MulticallService;
}(_servicesCore.PublicService);

exports["default"] = MulticallService;